import ReactHtmlParser from "@/src/utils/html-parser";
import { Box, Typography } from "@mui/material";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import { HEADING_SIZE } from "@/src/components/common/broadsheet/tokens";

const ArticleCopyRight = ({ copyright }: { copyright: string }) => {
  return (
    <Box component="section">
      <Typography component="h2" sx={{
        fontSize: HEADING_SIZE.section
      }}>
        <SpanTypography sx={{
          fontSize: HEADING_SIZE.section
        }}>Copyright</SpanTypography>
      </Typography>
      <Typography
        sx={{
          color: "text.secondary",
          fontSize: ".8rem"
        }}>
        {ReactHtmlParser(copyright)}
      </Typography>
    </Box>
  );
};

export default ArticleCopyRight;
